import { useEffect, useState } from 'react'

const BASE = '/vendor/highcharts'

function loadScript (src) {
  return new Promise((resolve, reject) => {
    if (document.querySelector(`script[src="${src}"]`)) {
      resolve()
      return
    }
    const script = document.createElement('script')
    script.src = src
    script.onload = () => resolve()
    script.onerror = (err) => reject(err)
    document.head.appendChild(script)
  })
}

// modules: optional array of additional Highcharts module names, e.g. ['highcharts-more']
export default function useHighcharts (modules = []) {
  const [loaded, setLoaded] = useState(false)

  useEffect(() => {
    const allScripts = [
      `${BASE}/highcharts.js`,
      ...modules.map(m => `${BASE}/${m}.js`)
    ]

    // If core is already present, skip it but still run modules through loadScript
    // so any missing module (e.g. highcharts-more) gets loaded.
    const toLoad = window.Highcharts
      ? allScripts.slice(1)
      : allScripts

    if (toLoad.length === 0) {
      setLoaded(true)
      return
    }

    toLoad.reduce((chain, src) => chain.then(() => loadScript(src)), Promise.resolve())
      .then(() => setLoaded(true))
      .catch(err => console.error('useHighcharts: failed to load scripts', err))
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return loaded
}
